import React from 'react';
import './AboutUs.css';
import { Target, Eye, Code, Rocket, Globe, Shield, Robot, Sparkle, ChatCircleDots, Brain, Cpu, Lightning, Atom, Lightbulb, MagicWand, Gear, Flask, Binoculars } from '@phosphor-icons/react';
import RevealOnScroll from './RevealOnScroll';

const AboutUs = () => {
    return (
        <section className="about-section">
            <div className="about-container">
                <div className="about-hero-original">
                    <div className="about-hero-left">
                        <div className="hero-image-collage">
                            <img src="/about_hero_1.png" alt="Robot Hand" className="hero-img-top" />
                            <div className="hero-img-bottom-wrapper">
                                <img src="/about_hero_2.png" alt="AI Face" className="hero-img-bottom" />
                                <div className="hero-tagline-box">
                                    <h4>Bridging Intelligence with Innovation</h4>
                                </div>
                            </div>

                            {/* AI Sprinkles */}
                            <div className="ai-sprinkles-container">
                                <div className="ai-sprinkle s1"><Robot size={60} weight="duotone" /></div>
                                <div className="ai-sprinkle s2"><Sparkle size={40} weight="fill" /></div>
                                <div className="ai-sprinkle s3"><ChatCircleDots size={45} weight="duotone" /></div>
                                <div className="ai-sprinkle s4"><Brain size={68} weight="duotone" /></div>
                                <div className="ai-sprinkle s5"><Cpu size={40} weight="duotone" /></div>
                                <div className="ai-sprinkle s6"><Lightning size={35} weight="fill" /></div>
                                <div className="ai-sprinkle s7"><Sparkle size={30} weight="fill" /></div>
                                <div className="ai-sprinkle s8"><Atom size={42} weight="duotone" /></div>
                                <div className="ai-sprinkle s9"><Lightbulb size={45} weight="duotone" /></div>
                                <div className="ai-sprinkle s10"><MagicWand size={38} weight="duotone" /></div>
                                <div className="ai-sprinkle s11"><Gear size={32} weight="duotone" /></div>
                                <div className="ai-sprinkle s12"><Flask size={30} weight="duotone" /></div>
                                <div className="ai-sprinkle s13"><Binoculars size={28} weight="duotone" /></div>
                                <div className="ai-sprinkle s14"><Robot size={48} weight="duotone" /></div>
                                <div className="ai-sprinkle s15"><Robot size={38} weight="duotone" /></div>
                                <div className="ai-sprinkle s16"><Sparkle size={32} weight="fill" /></div>
                                <div className="ai-sprinkle s17"><Brain size={45} weight="duotone" /></div>
                                <div className="ai-sprinkle s18"><Robot size={55} weight="duotone" /></div>
                                <div className="ai-sprinkle s19"><ChatCircleDots size={40} weight="duotone" /></div>
                                <div className="ai-sprinkle s20"><MagicWand size={45} weight="duotone" /></div>
                            </div>
                        </div>
                    </div>
                    <div className="about-hero-right">
                        <h1>About Cabptoid Technologies</h1>
                        <h3 className="subheading">Bridging Innovation with Intelligence</h3>
                        <img src="/logo.png" alt="Company Logo" style={{ maxWidth: '150px', margin: '20px 0' }} />
                        
                        <div className="about-paragraphs">
                            <p>
                                At Cabptoid Technologies, we help businesses unlock the power of Artificial Intelligence 
                                and modern software development to stay ahead in a rapidly evolving digital landscape. 
                                From AI consulting to custom app development, DevOps to cloud engineering, we provide 
                                end-to-end technology solutions tailored to startups, enterprises, and everything in between.
                            </p>
                            
                            <p>
                                Founded by a team of experienced technologists and innovation leaders, Cabptoid is built 
                                on the belief that technology should not only solve problems — it should spark progress. 
                                That’s why we combine strategic thinking, deep technical expertise, and a passion for 
                                innovation to help our clients transform ideas into intelligent, scalable, and 
                                future-ready digital solutions.
                            </p>
                            
                            <p>
                                Whether you’re building a product from scratch or modernizing legacy systems, our agile, 
                                collaborative approach ensures every solution is aligned with your goals and built 
                                to grow with you.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="about-stats">
                    {[
                        { val: "50+", lbl: "Projects Delivered" },
                        { val: "15+", lbl: "Tech Specialists" },
                        { val: "99%", lbl: "Client Satisfaction" },
                        { val: "24/7", lbl: "Expert Support" }
                    ].map((stat, i) => (
                        <RevealOnScroll key={i} delay={i * 100}>
                            <div className="stat-item">
                                <span className="stat-value">{stat.val}</span>
                                <span className="stat-label">{stat.lbl}</span>
                            </div>
                        </RevealOnScroll>
                    ))}
                </div>

                <div className="mission-vision">
                    <div className="mv-card">
                        <div className="mv-icon">
                            <Target size={40} weight="fill" />
                        </div>
                        <h2>Our Mission</h2>
                        <p>To empower global enterprises through precision engineering and future-ready technology solutions that drive measurable business impact.</p>
                    </div>
                    <div className="mv-card">
                        <div className="mv-icon">
                            <Eye size={40} weight="fill" />
                        </div>
                        <h2>Our Vision</h2>
                        <p>To redefine the standard of digital excellence, becoming the most trusted partner for companies navigating the complexities of modern transformation.</p>
                    </div>
                </div>

                <div className="core-values">
                    <RevealOnScroll><h2 style={{ textAlign: 'center', marginBottom: '60px' }}>Our Fundamental Values</h2></RevealOnScroll>
                    <div className="values-grid">
                        <RevealOnScroll delay={100}>
                            <div className="value-item">
                                <div className="value-icon"><Code size={32} /></div>
                                <h5>Innovation First</h5>
                                <p>We leverage cutting-edge tech stacks to build resilient solutions.</p>
                            </div>
                        </RevealOnScroll>
                        <RevealOnScroll delay={200}>
                            <div className="value-item">
                                <div className="value-icon"><Shield size={32} /></div>
                                <h5>Uncompromising Integrity</h5>
                                <p>Honest collaboration and radical transparency in every line of code.</p>
                            </div>
                        </RevealOnScroll>
                        <RevealOnScroll delay={300}>
                            <div className="value-item">
                                <div className="value-icon"><Globe size={32} /></div>
                                <h5>Global Perspective</h5>
                                <p>Designing solutions that scale across borders and industries.</p>
                            </div>
                        </RevealOnScroll>
                        <RevealOnScroll delay={400}>
                            <div className="value-item">
                                <div className="value-icon"><Rocket size={32} /></div>
                                <h5>Performance Driven</h5>
                                <p>Optimized for speed, efficiency, and exceptional UX.</p>
                            </div>
                        </RevealOnScroll>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default AboutUs;
